module.exports = __webpack_public_path__ + "static/img/(1959)_05_16_AnnArbor_Program.4630cc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/thumbs/(1959)_05_16_AnnArbor_Program.jpg
// module id = q7ok
// module chunks = 0